export enum VIOLATIONS_TABLE_TEST_IDS {
  // Actions
  ACTIONS_CONTAINER = 'vt-actions-container',
  DOWNLOAD_BUTTON = 'vt-download-button',

  // Summary
  SUMMARY = 'vt-summary',
  SUMMARY_TOTAL_ACTIVE = 'vt-summary-total-active',
  SUMMARY_TOTAL_UNDER_REVIEW = 'vt-summary-total-under-review',
  SUMMARY_TOTAL_SUSPENDED = 'vt-summary-total-suspended',
  SUMMARY_TOTAL_CLOSED = 'vt-summary-total-closed',
  SUMMARY_TOTAL_IGNORED = 'vt-summary-total-ignored',

  // Table Controls
  VIOLATION_TYPE_DROPDOWN = 'vt-violation-type-dropdown',
  VIOLATION_STATUS_DROPDOWN = 'vt-violation-status-dropdown',
  VIOLATION_SEARCH = 'vt-violation-search',
  VIOLATION_ADDITIONAL_FILTERS = 'vt-violation-additional-filters',
  VIOLATION_ADDITIONAL_FILTERS_POPUP = 'vt-violation-additional-filters-popup',
}
